export default function SVGHands({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <g id="Hands-2-2" data-name="Hands-2">
        <path
          d="M854.82,6395.4s86.86,70.2,98,94.86c3,32.54,4.07,65.6,7.74,72.82s25.06,30.44,25.06,30.44l32.14,40.14,17.06,36.48s6.43,5.51,8.92,5.11c11.94,1.05,15.48-16.4,15.48-16.4L1100,6674.2l54.71,11.55-8.4,18.37,4.33,5.38s28.86-.92,34.51-8.27a60.83,60.83,0,0,0,5.64,11.81l7.21,2.36,15-15.48,16.53-29.39,10,8.53,8.79-3,5.25-11.94,15-52.35.39-42.64-1.18-21.64,12.86-.66,5.77-5.25s-13.77-52.61-15-59.56-3.28-19.55-3.28-19.55l-22.82-52.75s-5.65-10.23-14-13-43.56-20.73-43.56-20.73l-10-7-.92-18.5s5.38-5-24.4,0c-36,5.25-59.57,9.19-59.57,9.19s7.09,60.87-2.1,83.57c-.39,2.76-2.75,10.5-2.75,10.5s-18.11-15.88-26-18.24-10.1-6.95-10.1-6.95-36.08-29.92-38.18-44.48c-24.41-2.23-158.89,11.15-158.89,11.28"
          fill="#f7f7f7"
        />
        <path
          d="M865.58,6389.37s99.06,81.21,100.37,109.68c.79,17.45,2.1,37,3,49.73a34.91,34.91,0,0,0,10,22.3c15.35,15.88,43.42,48.15,47.1,54.19,8.53,13.9,16.14,41.85,8.92,45a169.59,169.59,0,0,1-12.86-28.6c-30.17-46.58-47.1-51-58-71.25-9.58-17.84-11.41-80-11.41-80l-93.81-68.62Z"
          fill="#fff"
        />
        <path
          d="M1049.13,6573.84s34.9,38.57,28.34,91.84c-18.5-5.38-18-6.83-18-6.83s7.61-47.88-10.62-71c-13.78-20.07-17.45-23.61-14.43-23.22,9.7,10.89,14.69,9.19,14.69,9.19"
          fill="#ececec"
        />
        <path
          d="M1100,6627.1s104.43,33.85,140.64,31c-19.81,4.85-21.78,2.75-21.78,2.75l-115.72-27-10.49-3.29Z"
          fill="#ececec"
        />
        <path
          d="M1120.63,6595.75c-2.88,6,94.86,28.07,128.71,24.92-1.31,1.05-2.49,2-3.41,2.76a16.54,16.54,0,0,1-13.64,3.54l-49.2-8.66-50.39-11-9.44-5.51S1119.45,6596.93,1120.63,6595.75Z"
          fill="#ececec"
        />
        <path
          d="M1246.46,6589.19c-28.61,6.69-44.22-3.68-74-7.74s-24.14,1.18-24.14,1.18l71.63,14.69,22.18-3.41,4.33-4.72"
          fill="#ececec"
        />
        <path
          d="M1117.75,6610.18s92.1,25.58,109.94,25.19c25.72,3,20.47,18.76,20.47,18.76s6.17-5.77,5.25-10.76-3.94-16.66-12.46-14.95-113.89-19-113.89-19Z"
          fill="#fff"
        />
        <path
          d="M1144.64,6583.54s-1.83,9.19,11.29,10.24,87.51,7.87,93.41,22.83c-2.88-10-5.9-10.5-5.9-10.5l-26.9-8.53-64.42-11.28-7.48-2.76"
          fill="#fff"
        />
        <path
          d="M1147.79,6542.87s5.25,5,9.84,9.71a44.23,44.23,0,0,0,24.28,12.73c24,3.8,57.07,2.49,64.41,22.43,2.89,1.45,1-4.06-1.31-8a17.56,17.56,0,0,0-11.54-8.4l-59-13.25-21.91-18.1-4.73,2.88"
          fill="#fff"
        />
        <circle cx="1084.16" cy="6571.61" r="18.63" fill="#fff" />
        <path
          d="M1118.93,6547.46a18.57,18.57,0,0,1,.92,37.13h-1c-10.24,0-18.63-10-18.63-20.33S1108.7,6547.46,1118.93,6547.46Z"
          fill="#fff"
        />
        <circle cx="1096.89" cy="6590.24" r="18.63" fill="#fff" />
        <path
          d="M1102.79,6571.61s16.14,13,26.37,0a17.12,17.12,0,0,0,0-22.31s12.73,7.74,8.27,21.78-15.88,16.79-21.91,14.17c-2.5-7.87-12.73-13.64-12.73-13.64"
          fill="#ececec"
        />
        <path
          d="M1072,6585.38s3.67-18.24,22.17-19.29c0-10,1.31-9.57,1.31-9.57l5.91,5.38-1.18,9.44s-20.73-2.88-23.23,17.58c-3.28,0-5-3.54-5-3.54h0"
          fill="#ececec"
        />
        <path
          d="M1078.26,6590.24s9.57,14.82,24.53,9.84,6-22.05,6-22.05,7.61,8.4,6.56,15-12.73,13.38-12.73,13.38l-6.17,1.18a13,13,0,0,1-10.49-2.36l-2-1.44-3.81-5-2-8.52"
          fill="#ececec"
        />
        <path
          d="M1081.67,6457.07c9.31,15.87,32.14,54.84,44.87,60.48s1.18-8.26,1.18-8.26l-16.93-18.9-15.74-24.4s-11-28.87-32.67-30.31l-5.38-2.36A66.93,66.93,0,0,1,1081.67,6457.07Z"
          fill="#fff"
        />
        <path
          d="M1195.94,6447.49a164,164,0,0,1,15.75,42.51c5,23.48,25.06,65.73,56.81,67.7l-.26-10.5s-25.85-13-32.54-28.47-10.24-38.31-13.38-39.62c-3.68-5.12-26.38-31.62-26.38-31.62"
          fill="#ececec"
        />
        <path
          d="M1088.36,6453.66s46.84,54.18,49.07,59.43,19,44.08,88.43,45.66c27.42,4.33,34.37,28.6,27.42,34.63s-9.19,6.56-9.19,6.56,10.76,2.89,12.6,12.21a13.8,13.8,0,0,1-3,11.15l-.78,1.05a4.75,4.75,0,0,0-.53,5.51c4.2,8,13.51,29.91-8.27,33.45-26.63,4.46-14.17,24.67-42.5,27.42s-36.08,1.71-46.19-3.41l1.71-1.31,22.3,2.89s23.88-3.68,33.85-6.82,8.79-20.21,5.78-21.26c9.44-.26,36.73-1,34.24-17.32s-20.73-13.64-20.73-13.64l4.72-3s12.07-2,12.07-6.17a91.93,91.93,0,0,0-1.44-11.94s-16.53-11.28-22.17-11.28,19.41,1.44,20.73-8.27-4.6-14.3-4.6-14.3-11.41-9.7-58.25-14c-19.42-.92-35.69-24.8-35.69-24.8l-8.52-13-4.6-3.15-3.14-6.69-18.5-19.81-24.8-39.75"
          fill="#ececec"
        />
        <path
          d="M1172.72,6347s-5,27,4.72,30.57c8.79,6,35,17.84,52.75,26.63a28.44,28.44,0,0,1,12.72,12.73c8,16.14,18.63,45.92,18.63,45.92s1.32,69.4,25.33,78.46a99.77,99.77,0,0,1-4.2-18.37s-11.29-45.13-14-60.62-23-52.87-23-52.87,3-7.61-41.46-27.42-26-13.25-26-13.25l-.39-21.78h-5.12"
          fill="#fff"
        />
        <path
          d="M1153.3,6689.42s-3,12.47,5.91,14.44a117.49,117.49,0,0,0,19.15,2.36l-19.55,5.64-11-2.63-1.18-4.85,2.76-9.32Z"
          fill="#fff"
        />
        <path
          d="M1188.07,6691.92s1.58,13.51,6.3,14.43,14.69-2,21.52-10.89-12.73,18.5-12.73,18.5l-7.48,1.31-6.82-3.67-4.59-7.74-1.58-6.83,4.86-5.11"
          fill="#fff"
        />
        <path
          d="M1230.45,6669s8.27,8.39,16,1.83a32.46,32.46,0,0,0,7.74-9.57c3.41,2-5.25,14.82-5.25,14.82l-8.79,3-5.51-3.67-2.36-3Z"
          fill="#fff"
        />
        <circle cx="967.65" cy="6362.95" r="138" fill="url(#linear-gradient-2)" />
      </g>
      <g id="Layer_7" data-name="Layer 7">
        <path
          d="M1063.43,6660.69c6.43,1.84,18.89,8.4,36.87,13.38a414.75,414.75,0,0,0,47.23,10.37c11.15,1.84,33.46,5.25,33.85,1.31.13-1.05-10.89-3.54-16-2.89-9.7.53-18.36,11.68-18.76,21.13-.39,12.2,32.8,2.75,34.51,1.44a4.29,4.29,0,0,0,1.57-4.33c-1.18-5.77.92-12.86,3.94-14.69,6-5.38,30.7-2.63,30.7-18.76,0-10.11,5.25-10.11,3.54-1-.26,1.31-.52,3.41-.65,4.72-1.32,13.51-17.59,12.86-27.43,15.87-3.67,1.19-6.56,3.15-7.34,7.61a16,16,0,0,0,0,6.17c2.23,7.48,5.25,15.35,12.86,14,3.67-.66,12.85-13.25,15-15.48,21.91-28.47,15.09-39.36,15.09-39.36,14.43-.53,24.93-7.35,24.8-17.06-.4-14.17-14-12.07-26.64-13.64-25.19-3.15-82.39-16.4-82.39-16.4l-17.32-3.81a15.57,15.57,0,0,0-16.53,6.82c-4.33,7-12.33,15.09-26,15.49-6.43.13-7.21-6.3-2.23-4.73,7.09,2.23,88.17,29.13,146.29,33.33,1.31,7.35,2.89,14.95,11.55,18.5a6.85,6.85,0,0,0,8.79-3c7.21-12.86,17.32-49.2,20.2-64.42,2.23-11.41.92-26.5.53-35.69-.27-8.39,0-20.33-1.32-28.73-6.82-3.67-15.61-7.08-20.86-12.33a70.36,70.36,0,0,1-9-11.55c-2.36-3.54-7.87-16-9.31-20.2-5.25-17.32-11.29-33.72-24.41-46.45-3-3-6.56-5.9-8.66-9.44a2,2,0,0,1,.92-2.63h0a1.85,1.85,0,0,1,1.84.13c7.61,5.64,14.43,12.47,18.89,20.86,8.14,15.49,7.74,33.85,16.14,49.34,7.48,14,18.89,27,34.37,32.27,5.12,1.71,24,.13,17.45-11.68-4.85-8.66-12.85-45.26-17.05-73.34a24.84,24.84,0,0,0-1.58-5.9c-9-22.31-19.15-40.54-21.25-47-5.64-16.14-44.87-22.44-57.6-33.72s-29.39-13.12-29.78-3.15c.39,6.3,18.5-.92,19.94-3.8,1.18-2.36-.39-9.45-.92-18.5a3.76,3.76,0,0,0-3.8-3.55,2.11,2.11,0,0,0-.92.14c-22.3,6.56-65.6,8.26-79.38,12.59,7,23.22-9.58,91.45-2.1,83.58,5.65-5.91,7.09-54.06,2.1-83.58-1.31-21.12-28.6-9.18-24.27,1.84a2.65,2.65,0,0,0,1.57,1.57c4.33,1.18,7.88-10.49-1.18-26-9.84-16.93-45.13-11.16-56.41,20.46-14.17,37.26,48.54,72.69,41.59,75.44-35.16-11.41-11.28,40.81,0,40.15,4.59-2.49-23.88-32.14-13.78-39.23s42,8.4,47.63,19.68,25.32,44.87,39.36,55.5-1.44,23.22-9.19,25.32c-5.9,1.58,2-9.31,10.37-13.38a8.78,8.78,0,0,1,10.36,2c6.17,6.82,15.22,18,1.71,22.3-6.56,2.49,3.54-14.43,21,4.46,13.91,15,45.66,13.65,66,18.76.13-11.41-.79-32.27-3.15-28.34-3.15,5.25,3.15,27,3.15,28.08v.26l1.18.27c12.46,3.14,18.89,9.7,17,20.2-5.9,21.39-103-12.46-101.81-5.64,16.14,10.89,115.2,7.22,104.7,37-3.94,4.85-9.45,7.48-24,5.77-18-2-44-9-92.5-19.15-13.12-2.76-10.49-11.94-16.92-22.05,31.75.27,29.12-43-1.45-38-18.36,4.06-15.61,23.61-13.9,24.14,6.43-17.72-20.34-25.46-31.62-13.52-7,8.14-5.38,23.88,8.4,31.1,3.54,27.68,37.39,21.38,38.31,2,0-1.05.39-11.68-9.06-17.58-7-4.6-27.29-3-29.12,15.61-4.73,2.36-15.22,1.83-23.49-10.24-9.71-13.9-1.7-51.16,4.72-46.31s-3.67,34.38-9.31,41.46-35.82-37.92-6.3,4.2,21.13,84.23,8.4,94.07-20.34-4.85-27.42-26.63-51.56-65.73-59.44-75.18c-9.71-11.42-6.56-50.51-10.75-68.88s8.39-29.52,10.49-26-11.28,14.7-11.28,14.7c-34.11-40.94-68.88-71.38-98-94.86"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </g>
  );
}

export function MobileSVGHands({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <path
        d="M294.7,3788.5s38.8,31.4,43.8,42.4c1.4,14.6,1.8,29.3,3.5,32.6s11.2,13.6,11.2,13.6l14.4,18,7.6,16.3,4,2.3,8.7-6.4,16.5,6,24.84,5.3-4,8.1,2,2.4s12.9-.4,15.4-3.7a28.31,28.31,0,0,0,2.6,5.3l3.2,1s4.82-5.4,6.7-6.9c4-3.22,8.3-13.15,8.3-13.15l3.6,3.85,3.9-1.3,2.4-5.4,6.7-23.4.2-19.1-.5-9.7,5.8-.3,2.6-2.3s-6.1-23.5-6.7-26.6c-.23-1.19-1.51-2.75-1.76-4.22-.51-3-.41-6-1.67-8.76l-8.27-18.32s-2.2-5-6-6.3S444,3780,444,3780l-4.4-3.1-.4-8.3s5.2-2.4-10.9,0-26.7,4.1-26.7,4.1,3.28,3.65-1.9,34.7c-.2,1.2-.2,7.4-.2,7.4s-8.1-7.1-11.6-8.1-4.5-3.1-4.5-3.1-16.1-13.4-17-19.9c-11.1-.9-71.2,5-71.2,5"
        fill="#f7f7f7"
      />
      <path
        d="M299.5,3785.8s44.3,36.3,44.9,49c.4,7.8,1,16.6,1.4,22.2a15.53,15.53,0,0,0,4.4,10c6.9,7.1,19.4,21.5,21.1,24.2,3.9,6.2,2.59,16.59,8,22.4-4,1.54-41.9-38-41.9-38l-15.1-47.5-25.7-27.7Z"
        fill="#fff"
      />
      <path
        d="M381.5,3868.2s15.6,17.2,12.7,41.1c-8.3-2.4-8-3.1-8-3.1s3.5-23.2-4.6-33.6-6.5-8.6-6.5-8.6l6.4,4.2"
        fill="#ececec"
      />
      <path d="M404.2,3892.1s46.7,14.3,62.9,13c-8.9,2.1-9.7,2-9.7,2l-51.7-12-4.7-1.4Z" fill="#ececec" />
      <path
        d="M414.6,3878.3s42,12.34,57.11,11c-.71,3.9-4.61,3.26-4.61,3.26l-26.2-3.1-22.1-6.4-4.2-2.4Z"
        fill="#ececec"
      />
      <path
        d="M470.67,3875.34c-12.7-.3-20.77-1.94-34.07-3.64s-10.8,1.7-10.8,1.7l32,5.4,9.9-1.5L470,3876"
        fill="#ececec"
      />
      <path
        d="M412.7,3885.5s40.6,10.4,48.6,10.2c11.5,1.3,10.65,8.44,10.65,8.44a10,10,0,0,0,.75-4.84c-.4-2.2-1.7-7.5-5.6-6.7s-50.9-8.5-50.9-8.5Z"
        fill="#fff"
      />
      <path
        d="M424.2,3872.6s-.9,4.1,5.1,4.5,39,5.5,41.6,12.1a37.08,37.08,0,0,0-2.5-6.6l-12.9-4.3-28.1-4.9-3.2-.8"
        fill="#fff"
      />
      <path
        d="M426.7,3854.33s5.6,6.37,6.2,7.77c9.1,5.2,29.8,1.8,36.7,11.7,1.3.7.74-1.76-.26-3.56a8.82,8.82,0,0,0-5.52-3.84l-26.42-5.2-9.8-8.1-.82.7"
        fill="#fff"
      />
      <circle cx="397.2" cy="3867.3" r="8.3" fill="#fff" />
      <circle cx="412.57" cy="3864.74" r="8.3" transform="matrix(0.02, -1, 1, 0.02, -3459.14, 4205.74)" fill="#fff" />
      <circle cx="402.8" cy="3875.6" r="8.3" fill="#fff" />
      <path
        d="M405.5,3867.3s7.2,5.8,11.8,0a7.6,7.6,0,0,0,0-10s5.7,3.4,3.7,9.7-9.8,6.3-9.8,6.3l-1.44-2.92-4.26-3.08"
        fill="#ececec"
      />
      <path
        d="M391.7,3873.4s1.7-8.2,9.9-8.6c-.07-3.2-.18-4.35.6-4.3,4.84.29,2.2,4.3,2.2,4.3v2.4s-9.3-1.3-10.3,7.8a3.13,3.13,0,0,1-2.4-1.6h0"
        fill="#ececec"
      />
      <path
        d="M394.5,3875.6s4.3,6.6,11,4.4,3.23-10.26,3.23-10.26,3.71,3.56,2.37,7.16c-1,2.77-5.6,6-5.6,6l-5.3,1-3-2.2-1.7-2.2-1-3.9"
        fill="#ececec"
      />
      <path
        d="M377.8,3805.8s14.1,3.2,18.2,10.2,14.75,25,20.45,27.54,2.44-2.88,2.44-2.88l-9.32-10.26-7-11s-5.87-14.07-15.57-14.77l-9.23,1.12"
        fill="#fff"
      />
      <path
        d="M447.1,3811.8a76.11,76.11,0,0,1,7,19c2.2,10.5,11.2,29.4,25.4,30.2l-.1-4.7s-11.5-5.8-14.5-12.7-4.7-20.8-6.9-21.2-10.9-10.6-10.9-10.6"
        fill="#ececec"
      />
      <path
        d="M399.89,3814.49S420,3838.8,421,3841.2s8.5,19.7,39.5,20.4c12.2,1.9,15.3,12.8,12.2,15.5s-4.1,3-4.1,3,7.5,2.1,5.4,9.1l-2.4,2.9s9,14.3-3,16.2-4.8,10.9-17.5,12.1-9.89,2.37-21.49-1.23l.19-.77s9.5,1.07,12.92.12a29.22,29.22,0,0,1,9.38-1.82c7.15-2.17,5.86-7,6.26-9.32,4.2-.1,15.44-.78,14.34-8.08-.75-5-3.86-5.82-5.77-5.85a1.45,1.45,0,0,1-1.43-1.55h0s5.4-.9,5.4-2.7-1.43-2.63-1.73-4.38c0,0-36.35-10.91-38.85-10.91s38.78,5.59,39.38,1.29a7,7,0,0,0-2-6.4s.31-3-26-6.3c-7.06-1.74-11.33-8.44-14.92-8.7-.61-2.88-3.41-8.3-6.61-9.48.7-3.84-5.49-6.92-9.43-12.32-3.51-3.87-10.85-17.51-10.85-17.51"
        fill="#ececec"
      />
      <path
        d="M436.7,3766.9s-2.2,12.1,2.1,13.7c3.9,2.7,15.7,8,23.6,11.9a12.13,12.13,0,0,1,5.7,5.7c3.6,7.2,8.4,20.5,8.4,20.5s1.52,31.59,12.22,35.69c-.88-2.67-2.44-6-2.82-8.79,0,0-5-20.2-6.3-27.1s-10.2-23.6-10.2-23.6,1.4-3.4-18.5-12.2c-8-3.32-11.3-5.8-11.3-5.8l-.5-9.9-2.4-.1"
        fill="#fff"
      />
      <path d="M428.6,3920.9s-1.9,4.6,2.1,5.5a48.75,48.75,0,0,0,8.6,1l-8.7,2.5-4.9-1.2-.5-2.2,1.2-4.1Z" fill="#fff" />
      <path
        d="M444.53,3921.15s-1,6.1,1.77,6.35c2,.4,5.63-1.21,10.1-4.74,4-3.15-6.25,8.64-6.25,8.64l-3.7.51-2.65-2.11-1.1-3.4-.88-4.82,2.71-.43"
        fill="#fff"
      />
      <path
        d="M463.4,3910.3s2.68,4.69,6.21,1.95a14.37,14.37,0,0,0,4.81-5.32c1.74,1.14-3,7.78-3,7.78l-4.51.59-2.5-1.6-1-1.3Z"
        fill="#fff"
      />
      <path
        d="M300.1,3771.8c20.3-7.2,85.9,10.3,98.9,27s-9.5,36.8-29.8,44-47.2-.5-60.2-17.2S279.8,3779,300.1,3771.8Z"
        fill="url(#linear-gradient)"
      />
    </g>
  );
}
